module.exports = __webpack_public_path__ + "img/service-edu3.171bae52.svg";